<div
  (click)="onClick()"
  class="flex items-center justify-center w-full bg-yellow-500 rounded-lg py-3 px-5 cursor-pointer lg:w-max">
  <div class="circle-plus flex items-center justify-between rounded-full bg-yellow-300 mr-3 p-1">
    <img src="assets/images/black-plus.svg " width="16" height="16" />
  </div>
  <span data-test-id="create-placeholder" class="text-gray-800 font-medium text-base">{{ createText }}</span>
</div>
